import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { T } from '@fullcalendar/core/internal-common';
import {
  ApiPaginatedResponse,
  ApiQuery,
  apiQueryToHttpParams,
  ApiResponse,
} from '@kinet-open-network/client/core/api-client';
import {
  toModel,
  toModelArray,
} from '@kinet-open-network/client/shared/data-access/model';
import { map, Observable } from 'rxjs';
import { InvoiceCustomer } from '../models/invoice-customer.model';

@Injectable({
  providedIn: 'root',
})
export class InvoiceCustomersService {
  protected http = inject(HttpClient);

  query(
    query?: ApiQuery | null,
  ): Observable<ApiPaginatedResponse<InvoiceCustomer>> {
    return this.http
      .get<ApiPaginatedResponse<T>>('/customers', {
        params: apiQueryToHttpParams(query),
      })
      .pipe(
        map(({ data, ...response }) => ({
          ...response,
          data: toModelArray(data, InvoiceCustomer),
        })),
      );
  }

  findOne(id: string): Observable<InvoiceCustomer> {
    return this.http
      .get<ApiResponse<InvoiceCustomer>>(`/customers/${id}`)
      .pipe(map((data) => toModel(data, InvoiceCustomer, 'data')));
  }

  refreshCustomers() {
    return this.http.post<void>('/invoicing/customers/refresh', {});
  }
}
